import { getShape1D } from 'ml-peak-shape-generator';
/**
 * Append a `shape` property (including `fwhm`) to every peak.
 * @param peaks - Peaks with a `width` property.
 * @param options - Shape options.
 * @returns A peak list where every peak has a `shape` property.
 */
export function setShape(peaks, options = {}) {
    const { shape = { kind: 'gaussian' }, output = structuredClone(peaks) } = options;
    const shapeInstance = getShape1D(shape);
    return output.map((peak) => ({
        ...peak,
        shape: { fwhm: shapeInstance.widthToFWHM(peak.width), ...shape },
    }));
}
//# sourceMappingURL=setShape.js.map